import { createSlice } from "@reduxjs/toolkit";

const initialState ={
isgloading:false,
gstatus:"",
gmessage:"",
guroles: {}
};

const userRoleGetSlice = createSlice({
    name:"userRoleGet",
    initialState,
    reducers:{
        getRolePending:(state,action) => {
            state.isgloading=true;
            state.gstatus="";
        },
        getRoleSuccess:(state,{payload}) => {
            state.isgloading=false;
            state.gstatus="success";
            state.guroles=payload;
            state.gmessage="";
        },
        getRoleFail:(state,{payload}) => {
            state.isgloading=false;
            state.gstatus="fail";
           // console.log('slice '+payload);
            state.gmessage=payload;
        }


    }
});

const {reducer,actions} = userRoleGetSlice;
export const{getRolePending,getRoleSuccess,getRoleFail}=actions;
export default reducer;

